import React from "react";
import { Link } from "react-router-dom";
import Grain from "../components/Grain";

const VALEURS = [
  { n: "01", titre: "Authenticité", texte: "Capter les vrais moments. Pas les poses, mais les présences." },
  { n: "02", titre: "Maîtrise technique", texte: "La lumière est mon outil. La composition, mon langage." },
  { n: "03", titre: "Confiance", texte: "Créer un espace où chacun se sent à sa place, devant l'objectif." },
];

export default function APropos() {
  return (
    <div className="pt-28">
      <section className="section-dark py-20 md:py-28 px-6 md:px-12 relative overflow-hidden" data-testid="apropos-hero">
        <Grain />
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] glow-amber-soft pointer-events-none" />
        <div className="max-w-[1280px] mx-auto relative z-10">
          <div className="eyebrow mb-6">À propos</div>
          <h1 className="h-display text-6xl md:text-8xl">L'œil derrière <br/><span className="italic-accent">l'objectif.</span></h1>
        </div>
      </section>

      <section className="section-dark px-6 md:px-12 pb-20" data-testid="apropos-bio">
        <div className="max-w-[1280px] mx-auto grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7 space-y-6 text-text-cream/80 font-light text-lg leading-relaxed">
            <p>
              Photographe portrait basé à Écublens, j'ai construit Studio Euclides autour d'une
              conviction : chaque visage raconte une histoire qui mérite d'être capturée avec soin.
            </p>
            <p>
              Originaire du Cap-Vert et établi en Suisse depuis plus de quinze ans, je partage mon
              temps entre la direction de mes entreprises et la photographie — une passion que je
              cultive depuis plus de quinze ans et qui occupe désormais la moitié de ma vie
              professionnelle.
            </p>
            <p>
              Aujourd'hui, je photographie celles et ceux qui me confient les instants les plus
              importants de leur vie : grossesses, mariages, séances famille, portraits professionnels.
              J'organise également des workshops d'éclairage pour transmettre ce que j'ai appris.
            </p>
            <p>
              Le studio se trouve à Écublens, à 10 minutes de Lausanne. J'y accueille mes clients
              en français, portugais, anglais ou créole capverdien.
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="/images/generated/about_euclides.jpg"
                alt="Euclides Tavares"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="eyebrow mt-4 text-text-cream/50">Euclides Tavares · Photographe portrait</div>
          </div>
        </div>
      </section>

      <section className="section-cream py-24 md:py-32 px-6 md:px-12" data-testid="apropos-valeurs">
        <div className="max-w-[1280px] mx-auto">
          <div className="eyebrow-dark mb-3">Mes trois piliers</div>
          <h2 className="font-serif text-5xl md:text-6xl font-light mb-16">Ce qui me <span className="italic text-accent-deep">guide.</span></h2>
          <div className="grid md:grid-cols-3 gap-12">
            {VALEURS.map((v) => (
              <div key={v.n} data-testid={`valeur-${v.n}`} className="border-t border-text-dark/20 pt-6">
                <div className="font-serif text-6xl italic text-accent-deep">{v.n}</div>
                <h3 className="font-serif text-3xl mt-4">{v.titre}</h3>
                <p className="mt-3 text-text-dark/70 font-light leading-relaxed">{v.texte}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-dark py-20 px-6 md:px-12 text-center" data-testid="apropos-cta">
        <Link to="/contact" className="btn-primary">Réserver une rencontre</Link>
      </section>
    </div>
  );
}
